import {
  Box,
  Toolbar,
  Typography,
  Modal,
  Card,
  TextField,
  Button,
  Divider,
  Checkbox,
  Paper,
  Grid2,
  Link,
  IconButton,
  CircularProgress,
  Backdrop,
  TablePagination,
  TableContainer,
  Table,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { Component } from "react";

import Appbar from "./Appbar";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
////// jewellery category
import FavoriteIcon from "@mui/icons-material/Favorite";
import Footer from "./Footer";
import Slider from "@mui/material/Slider";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import base_url from "./base_url";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer, toast } from "react-toastify";
 import FilterAltIcon from '@mui/icons-material/FilterAlt';
import bg2 from "./bachround_img/bg.jpg";
import bg from "./bachround_img/bg2.jpg";
import bg3 from "./bachround_img/bg3.jpg";
import bg4 from "./bachround_img/bg4.jpg";
import bg5 from "./bachround_img/bg5.png";

import product1 from "./product_img/product1.png";

import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import {CssBaseline} from '@mui/material';
import { grey } from '@mui/material/colors'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PersonIcon from '@mui/icons-material/Person';

import SearchIcon from "@mui/icons-material/Search";
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import LandslideIcon from '@mui/icons-material/Landslide';

const MAX = 100000;
const MIN = 0;
const marks = [
  {
    value: MIN,
    label: "",
  },
  {
    value: MAX,
    label: "",
  },
];

const drawerBleeding = 56;
const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: grey[100],
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.background.default,
  }),
}));

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.applyStyles('dark', {
    backgroundColor: grey[800],
  }),
}));



export class ItemList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_value: 900000,
      category: "",
      type: "",

      productList: [],
      size: 0,
      page: 0,
      rowsPerPage: 16,

      ////// is loader shows
      is_loader_open: true,

      wishListItemArrayId: [],

      categoryList: [],

      open:false,
    };
  }

  componentDidMount() {
    fetch(`${base_url.base}/category/retriveCategoryListForselect`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        console.log(result);
        this.setState({
          categoryList: result.data,
        });
      });

    if (this.props.location.state) {
      this.setState(
        {
          category: this.props.location.state.category,
        },
        () => {
          fetch(
            `${base_url.base_url}/product/retriveProductList/:${this.state.type}/:${this.state.category}/:${this.state.page}/:${this.state.rowsPerPage}`,
            {
              headers: {
                "content-type": "application/json",
              },
              method: "get",
            },
          )
            .then((res) => {
              return res.json();
            })
            .then((result) => {
              this.setState({
                productList: result.data,
                size: result.size,
                is_loader_open: false,
              });
            });
        },
      );
    } else {
      /// retrive data for listing
      fetch(
        `${base_url.base_url}/product/retriveProductList/:${this.state.type}/:${this.state.category}/:${this.state.page}/:${this.state.rowsPerPage}`,
        {
          headers: {
            "content-type": "application/json",
          },
          method: "get",
        },
      )
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          this.setState({
            productList: result.data,
            size: result.size,
            is_loader_open: false,
          });
        });
    }
    this.retriveWishListId();
  }

  retriveProductList = () => {
    fetch(
      `${base_url.base_url}/product/retriveProductList/:${this.state.type}/:${this.state.category}/:${this.state.page}/:${this.state.rowsPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      },
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          productList: result.data,
          size: result.size,
          is_loader_open: false,
        });
      });
  }; 

  addItemInCartList = async (product_id) => {
    let email = await localStorage.getItem("email");
    if (product_id !== "" && email !== null) {
      fetch(`${base_url.base_url}/cartList/addItemsInCart`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          email: email,
          product_id: product_id,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if (result.status) {
            this.Sucessfull();
          } else {
            this.Fail();
          }
        });
    } else {
       this.props.navigate('/login')
    }
  };

  addItemInWishList = async (product_id) => {
    let email = await localStorage.getItem("email");
    if (product_id !== "" && email !== null) {
      fetch(`${base_url.base_url}/wishList/addItemsInWish`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          email: email,
          product_id: product_id,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if (result.status) {
            this.Sucessfull();
            this.retriveWishListId();
          } else {
            this.retriveWishListId();
            this.removeFromWish();
          }
        });
    } else {
     this.props.navigate('/login')
    }
  };

  retriveWishListId = async () => {
    let email = await localStorage.getItem("email");
    if (email !== null) {
      fetch(`${base_url.base_url}/wishList/retriveIdWishList`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          email: email,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          this.setState({
            wishListItemArrayId: result.list,
          });
        });
    }
  };

  removeFromWish = () => {
    toast.success("Removed from wishList ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  Sucessfull = () => {
    toast.success("Item added ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  Fail = () => {
    toast.error("Item already exists ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      //transition: Bounce,
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
      },
      () => {
        this.retriveProductList();
      },
    );
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: event.target.value,
        page: 0,
      },
      () => {
        this.retriveProductList();
      },
    );
  };

  getValue = (e) => {};



   toggleDrawer=(newOpen)=> {
     this.setState({
      open:true
    })
    
  };

   toggleDrawerr=(newOpen)=>  {
    this.setState({
      open:false
    })
  };





  render() {
    let wishListId = this.state.wishListItemArrayId;
    console.log(wishListId);
    return (
      <div>
        <Box
          sx={{
            pt: 4,

            backgroundImage: `url(${bg2})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            minHeight: 1000, // Mandatory for visibility if content is empty
            width: "100%",
          }}
        >
          <Box
            sx={{
              height: 50,
              width: "100%",
              backgroundColor: "#1d294f",
              mt: 4,
            }}
          >
            <Container maxWidth="xl">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    fontWeight: "500",
                    color: "#fff",
                    mt: 1.5,
                    textTransform: "uppercase",
                  }}
                >
                  Price List and products details
                </Typography>

                <CircularProgress
                  sx={{ ml: 2, color: "#ab266c", mt: 1 }}
                  size={30}
                />
              </Box>
            </Container>
          </Box>

          <Box
            sx={{
              minHeight: 300,
              width: "100%",
              // backgroundColor: "#f5f5ff",
              display: this.state.is_loader_open ? "none" : "block",
            }}
          >
            <Container maxWidth="xl">
              <Box
                sx={{
                  minHeight: 200,
                  width: "100%",
                  // backgroundColor: "#f5f5ff",
                  pt: 2,
                }}
              >
                <Grid2 container spacing={{ xs: 1, sm: 2, md: 2 }}>
                  <Grid2 sx={{display:{xs:'none',sm:'block'}}} item size={{ xs: 12, sm: 2, md: 2 }}>
                                    <Paper
                      elevation={0}
                      sx={{
                        backgroundColor: "#fff",
                        minHeight: 500,
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 17,
                            fontWeight: "700",
                            textTransform: "uppercase",
                            color: "#1d294f",
                            pl: 2,

                            pb: 1,

                          }}
                        >
                          Filter
                        </Typography>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            this.setState({ category: "", type: "" }, () => {
                              this.retriveProductList();
                            })
                          }
                          disableElevation
                          startIcon={<CloseIcon />}
                          sx={{
                            textTransform: "none",
                            mr: 1,
                            height: 25,
                            backgroundColor: "#ab266c",
                          }}
                        >
                          Clear Filter
                        </Button>
                      </Box>

                      <Divider
                        sx={{ backgroundColor: "#ab266c", ml: 0.5, mr: 0.5 }}
                      />

                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "600",
                          textTransform: "uppercase",
                          color: "#1d294f",
                          ml: 2,
                          mt: 2,
                          mb: 2,
                        }}
                      >
                        Select Category
                      </Typography>

                      {this.state.categoryList.map((e) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "left",
                            alignItems: "center",
                            ml: 1,
                            mt: -1,
                          }}
                        >
                          <Checkbox
                            size="small"
                            checked={
                              this.state.category == e.category_name
                                ? true
                                : false
                            }
                            onClick={() =>
                              this.setState(
                                { category: e.category_name,open:false },
                                () => {
                                  this.retriveProductList();
                                },
                              )
                            }
                          />{" "}
                          <Typography
                            sx={{ fontSize: 12, textTransform: "uppercase" }}
                          >
                            {e.category_name}
                          </Typography>
                        </Box>
                      ))}
                    </Paper>
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 10, md: 10 }}>
                    <Grid2 container spacing={{ xs: 1, sm: 1, md: 2 }}>
                      {this.state.productList.map((i) => (
                        <Grid2 item size={{ xs: 12, sm: 4, md: 3 }}>
                          <Paper
                            variant="outlined"
                            sx={{ width: "100%", minHeight: 200 }}
                          >
                            <img
                              onClick={() =>
                                this.props.navigate(
                                  `/itemDescription/:${i.product_id}`,
                                )
                              }
                              src={base_url.base+'/'+i.thumb_nail_img}
                              style={{
                                height: 260,
                                width: "100%",
                                backgroundImage: `url(${bg})`,
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                borderTopRightRadius: 2,
                                borderTopLeftRadius: 2,
                                backgroundPosition: "center", // Mandatory for visibility if content is empty
                                width: "100%",
                              }}
                            />
                            <Divider />
                            <Box
                              sx={{
                                width: "100%",
                                height: 70,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "left",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 13,
                                  fontWeight: "600",
                                  // textTransform: "uppercase",
                                  color: "#c11778",
                                  ml: 0.5,
                                  textAlign: "left",
                                  fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                                }}
                              >
                                {i.product_name}
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 13,
                                    fontWeight: "500",
                                    // textTransform: "uppercase",
                                    color: "#1b7bce",
                                    ml: 0.5,
                                    mt: 0.5,
                                  }}
                                >
                                  ₹ {i.price} / {i.weight}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <IconButton
                                    onClick={this.addItemInWishList.bind(
                                      this,
                                      i.product_id,
                                    )}
                                    size="small"
                                    color="primary"
                                    aria-label="add to shopping cart"
                                    sx={{
                                      mr: 0.5,
                                      color: "#ab266c",
                                      display: wishListId.includes(i.product_id)
                                        ? "block"
                                        : "none",
                                    }}
                                  >
                                    <FavoriteIcon />
                                  </IconButton>

                                  <IconButton
                                    onClick={this.addItemInWishList.bind(
                                      this,
                                      i.product_id,
                                    )}
                                    size="small"
                                    color="primary"
                                    aria-label="add to shopping cart"
                                    sx={{
                                      mr: 0.5,
                                      display: wishListId.includes(i.product_id)
                                        ? "none"
                                        : "block",
                                    }}
                                  >
                                    <FavoriteBorderIcon />
                                  </IconButton>

                                  <Button
                                    onClick={this.addItemInCartList.bind(
                                      this,
                                      i.product_id,
                                    )}
                                    size="small"
                                    variant="contained"
                                    disableElevation
                                    sx={{
                                      textTransform: "none",
                                      fontSize: 13,
                                      mr: 0.5,
                                      height: 26,
                                    }}
                                  >
                                    Add Cart
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </Paper>
                        </Grid2>
                      ))}

                      <Grid2
                        item
                        sx={{
                          display:
                            this.state.productList.length > 0 ? "none" : "flex",
                        }}
                        size={{ xs: 12, sm: 12, md: 12 }}
                      >
                        <Box
                          sx={{
                            height: 400,
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        ></Box>
                      </Grid2>
                    </Grid2>

                    <Paper
                      sx={{
                        width: "100%",
                        display:
                          this.state.productList.length > 0 ? "block" : "none",
                        overflow: "hidden",
                        mt: 2,
                      }}
                    >
                      <TablePagination
                        sx={{
                          display:
                            this.state.productList.length > 0
                              ? "block"
                              : "none",
                        }}
                        rowsPerPageOptions={[8, 16, 32]}
                        component="div"
                        count={this.state.size}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </Paper>
                  </Grid2>
                </Grid2>
              </Box>
            </Container>
            <br />
          </Box>
        </Box>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          //transition={Bounce}
        />


   <Box >
            <Root>
                  <CssBaseline />
                  <Global
                    styles={{
                      '.MuiDrawer-root > .MuiPaper-root': {
                        height: '100%',
                        overflow: 'visible',
                      },
                    }}
                  />
                  <SwipeableDrawer
                   // container={container}
                    anchor="bottom"
                    open={this.state.open}
                    onClose={this.toggleDrawerr}
                    onOpen={this.toggleDrawer}
                    swipeAreaWidth={drawerBleeding}
                    disableSwipeToOpen={false}
                    ModalProps={{
                      keepMounted: true,
                    }}
                  >
                    <StyledBox
                      sx={{
                        position: 'absolute',
                        top: -drawerBleeding,
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                      }}
                    >
                    </StyledBox>
            
            
                    <StyledBox sx={{  pb: 2, height: '100%', overflow: 'auto' }}>


                      <Box sx={{height:120,width:'100%',backgroundColor:'#09488b'}}>


                               <Paper
                      elevation={0}
                      sx={{
                        backgroundColor: "#fff",
                        minHeight: 500,
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 17,
                            fontWeight: "700",
                            textTransform: "uppercase",
                            color: "#1d294f",
                            pl: 2,

                            pb: 1,

                          }}
                        >
                          Filter
                        </Typography>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            this.setState({ category: "", type: "" ,open:false}, () => {
                              this.retriveProductList();
                            })
                          }
                          disableElevation
                          startIcon={<CloseIcon />}
                          sx={{
                            textTransform: "none",
                            mr: 1,
                            height: 25,
                            backgroundColor: "#ab266c",
                          }}
                        >
                          Clear Filter
                        </Button>
                      </Box>

                      <Divider
                        sx={{ backgroundColor: "#ab266c", ml: 0.5, mr: 0.5 }}
                      />

                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "600",
                          textTransform: "uppercase",
                          color: "#1d294f",
                          ml: 2,
                          mt: 2,
                          mb: 2,
                        }}
                      >
                        Select Category
                      </Typography>

                      {this.state.categoryList.map((e) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "left",
                            alignItems: "center",
                            ml: 1,
                            mt: -1,
                          }}
                        >
                          <Checkbox
                            size="small"
                            checked={
                              this.state.category == e.category_name
                                ? true
                                : false
                            }
                            onClick={() =>
                              this.setState(
                                { category: e.category_name,open:false },
                                () => {
                                  this.retriveProductList();
                                },
                              )
                            }
                          />{" "}
                          <Typography
                            sx={{ fontSize: 12, textTransform: "uppercase" }}
                          >
                            {e.category_name}
                          </Typography>
                        </Box>
                      ))}
                    </Paper>
            
                      </Box>
                      
            
            
            
            
          
                  
            <Paper onClick={()=>this.setState({open:false})} elevation={2} sx={{height:60,display:'flex',position:'absolute',bottom:0,left:0,right:0,justifyContent:'right',alignItems:'center'}}>
            <Button onClick={()=>this.setState({open:false},this.retriveProductList())} variant="contained" sx={{height:30,mr:2}}>Search</Button>
            </Paper>
            
            
                    </StyledBox>
                  </SwipeableDrawer>
                </Root>
            </Box>
            
           

         <Paper onClick={()=>this.setState({open:true})} elevation={2} sx={{display:'flex',position:'sticky',height:50,width:50,backgroundColor:'#e86f0a',bottom:44,left:15,borderRadius:4,justifyContent:'center',alignItems:'center'}}>
          <FilterAltIcon sx={{color:'#fff',height:35,width:35}}/>
         </Paper>



      </div>
    );
  }
}

export default ItemList;

export function ItemListc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  return (
    <ItemList
      params={params}
      navigate={navigate}
      location={location}
    ></ItemList>
  );
}
